<div class="block-data">
    <div *ngIf="!isEditMode && text" class="actual-data" [innerHTML]="text | safeHtml"></div>
    <angular-editor *ngIf="isEditMode" id="editableText" [(ngModel)]="text" [config]="editorConfig"
    (keyup.esc)="changeToEditMode()"></angular-editor>

    <!-- <quill-editor name="Editable_Text_static" [(ngModel)]="text" *ngIf="isEditMode"
      [modules]="quillModules" (keyup.esc)="changeToEditMode()"></quill-editor> -->

    <div *ngIf="!text && !isEditMode" class="default-container">
      <div class="default-data">
        <div style="font-weight: 600; font-size: 16px;">
          Editable Text
        </div>
        <div style="margin: 10px 0px;">To add items to this section enter Edit mode by clicking button below
        </div>
        <div>
          <button type="button" class="btn btn-rbv" (click)="changeToEditMode()"><i
              class="fa fa-pencil editButtonIcon mr-2"></i>Edit mode</button>
        </div>
      </div>
    </div>
</div>
